import { DocList } from "../DocList";

/** What personal data the suite handles, what for, and that none of it is sold. */
export function PersonalDataUse(): React.JSX.Element {
  return (
    <>
      <h3>What data we handle</h3>
      <DocList>
        <li>Identification: your name and your work email.</li>
        <li>
          Access: your password (stored only in a form that can't be read back), your second factors (authenticator app, passkeys and
          recovery codes), your open sessions, and the IP address and browser used for each sign-in.
        </li>
        <li>Your organizations, your role in each one and any other roles you have.</li>
        <li>What you create in the suite&apos;s modules: messages, boards, cards, files, notes and similar content.</li>
        <li>The audit trail: a record of the important actions taken in the suite, who took them and when.</li>
      </DocList>

      <h3>What we use it for, and why we may</h3>
      <DocList>
        <li>To run the suite and give you access to it, as part of your contract or working relationship with your organization.</li>
        <li>
          To keep the suite secure and keep an audit trail, based on a legitimate interest in protecting people and information and on
          our legal obligations.
        </li>
        <li>To send you emails about your account (invitations, password resets, security notices), on the same grounds.</li>
      </DocList>

      <h3>No selling and no advertising</h3>
      <p>
        We don&apos;t sell your personal data and we don&apos;t share it for advertising. The suite has no analytics or advertising
        trackers. It uses only the cookies that are strictly necessary to work: one that keeps you signed in and one that protects
        your requests from forgery. That is why you won&apos;t see a cookie banner.
      </p>
    </>
  );
}
